<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5"
                    >REQUISIÇÕES
                    <b-button
                        variant="danger"
                        @click.stop="fechar()"
                        class="float-right btn-sm"
                        v-if="mostrarBtnFechar"
                    >
                        <span> <i class="fa fa-history"></i> Fechar </span>
                    </b-button>
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <app-tabela
                    idTabela="tblRequisicoes"
                    :itens="requisicoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="valor" slot-scope="data">{{
                        data.valor | currency
                    }}</template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharRequisicao(data)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view
            :contrato="contrato"
            :requisicoes="requisicoes"
            :dataServico="dataServico"
        ></router-view>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            erros: [],
            requisicoes: [],
            campos: [
                {
                    key: 'dataRequisicao',
                    label: 'Data Requisição',
                    sortable: true,
                    filterable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    filterable: true
                },
                {
                    key: 'objeto',
                    label: 'Objeto',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'solicitante',
                    label: 'Solicitante',
                    filterable: true
                },
                {
                    key: 'contatoSolicitante',
                    label: 'Contato',
                    filterable: true
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterRequisicoes() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.$route.name === 'FornecedoresContratos_Requisicoes') {
                promisse = this.dataServico.obterRequisicoes(
                    this.$route.params.fornecedorId,
                    this.$route.params.codContrato
                )
            } else {
                promisse = this.dataServico.obterRequisicoes(
                    this.$route.params.codContrato
                )
            }
            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.requisicoes = response.data
                    } else {
                        this.erros = ['Erro ao obter requisições']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        fechar() {
            if (this.$route.name == 'FornecedoresContratos_Requisicoes') {
                this.$router.push({ name: 'FornecedoresContratos_Detalhar' })
            } else {
                this.$router.push({ name: 'FornecedorContratos_Detalhar' })
            }
        },

        detalharRequisicao(requisicao) {
            let nextRoute = 'FornecedorContratos_RequisicaoDetalhar'
            if (this.$route.name === 'FornecedoresContratos_Requisicoes') {
                nextRoute = 'FornecedoresContratos_RequisicaoDetalhar'
            }
            this.$router.push({
                name: nextRoute,
                params: {
                    idRequisicao: requisicao.idRequisicao
                }
            })
        }
    },

    created() {
        this.obterRequisicoes()
    },

    computed: {
        isRotaContratosRequisicoes() {
            return (
                this.$route.name === 'FornecedorContratos_Requisicoes' ||
                this.$route.name === 'FornecedoresContratos_Requisicoes'
            )
        },

        mostrarTabela() {
            return this.isRotaContratosRequisicoes
        },

        mostrarBtnFechar() {
            return this.isRotaContratosRequisicoes
        }
    },

    watch: {},

    components: {}
}
</script>
